import type { Listing } from '@/services/api';
import { useCallback } from 'react';

export const useShareListing = (listing: Listing | null) => {
    return useCallback(async (e: React.MouseEvent): Promise<{ success: boolean; message: string }> => {
        e.preventDefault();
        e.stopPropagation();

        if (!listing?.product) {
            return { success: false, message: 'Invalid listing data' };
        }

        const listingUrl = new URL(`/listings/${listing.ss_slug}`, window.location.origin);
        const utmParams = {
            utm_source: 'share_button',
            utm_medium: 'social',
            utm_campaign: 'product_share',
            utm_content: 'closet_share'
        };

        Object.entries(utmParams).forEach(([key, value]) => {
            listingUrl.searchParams.set(key, value);
        });

        const shareUrl = listingUrl.toString();
        const shareData = {
            url: shareUrl,
            text: '\n\nShould I buy this? 👀'
        };

        try {
            const hasNativeShare = 'share' in navigator;
            const shareMethod = hasNativeShare ? 'native_share' : 'clipboard';

            if (hasNativeShare) {
                await navigator.share(shareData);
            } else {
                await navigator.clipboard.writeText(shareUrl);
            }

            return {
                success: true,
                message: shareMethod === 'native_share' ? 'Shared successfully!' : 'Link copied to clipboard!'
            };
        } catch (error) {
            if ((error as Error).name !== 'AbortError') {
                console.error('Share/copy failed:', error);
            }
            return {
                success: false,
                message: 'Unable to share or copy link. Please try again.'
            };
        }
    }, [listing]);
};